import { useEffect, Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ArrowForward from '@material-ui/icons/ArrowForward';
import CircularProgress from '@material-ui/core/CircularProgress';

import { useAuth } from '../../../contexts/auth';
import { useStepperContext } from '../hooks/useStepper';
import { VaccineValues } from '../validation';
import { UserVaccination } from "../../../services/models";

import LeaveButton from '../../../components/LeaveButton';
import { VaccineIcon } from '../../../assets/icons';
import useStyles from '../styles';

interface Props {
  loading: boolean;
  vaccination: UserVaccination;
}

function VaccineFirstStep(props: Props) {
  const { vaccination, loading } = props;
  const { locationComplement } = vaccination;

  const { user } = useAuth();
  const { handleNext, reset } = useStepperContext<VaccineValues>();
  const classes = useStyles();

  const handleCanSchedule = (gpid: number) => {
    const GPIDs = [80185976,
      40113808,
      40294871,
      80092454,
      40209721,
      80007212,
      40208458,
      80174405,
      40278460,
      80307038,
      80027136,
      40123136,
      80133365,
      40111257,
      80264413,
      80045148,
      80309458,
      40296242,
      80179884,
      40178930,
      80226580,
      80222482,
      80163571,
      80229854,
      80122104,
      80189664,
      80027201,
      80208969,
      40186628,
      80309576,
      80133390,
      80009530,
      80176148,
      80327983,
      80094325,
      80264457,
      80014472,
      80309693,
      80226536,
      40296230,
      80064040,
      25000072,
      80022754,
      80147722,
      40218301,
      20207053,
      80315762,
      80042657,
      80106428,
      80096946,
      80040982,
      20201730,
      80295066,
      80230559,
      80034548,
      80179302,
      40208416,
      80171634,
      80028474,
      80039390,
      80135842,
      40221192,
      80087039,
      80307043,
      80032164,
      40173624,
      40023269,
      80022888,
      80244213,
      80007279,
      80014491,
      40201065,
      40300929,
      80229126,
      80259222,
      40296701,
      20204347,
      40118477,
      40256308,
      40297096,
      40247919,
      80022711,
      20201859,
      80016368,
      40259655,
      20201808,
      80129732,
      40204951,
      80112205,
      80014425,
      80183705,
      80010262,
      40170319,
      40146067,
      80027414,
      40293759,
      40037733,
      40182016,
      20205612,
      40215719,
      80244120,
      40099072,
      80145855,
      80164308,
      80009378,
      80097606,
      80309731,
      80022964,
      40301615,
      40267491,
      80153456,
      40108244,
      40301370,
      40265410,
      20201436,
      80201930,
      40299772,
      80030331,
      40221455,
      80259219,
      40173538,
      40220780,
      40215122,
      80013589,
      80093650,
      40112465,
      40179166,
      40300984,
      40200405,
      80021887,
      80309533,
      80228650,
      80309866,
      40041171,
      20200656,
      20201368,
      20200685,
      40299104,
      40191597,
      80247245,
      80228813,
      80035543,
      80133369,
      80234098,
      80300442,
      80058601,
      80196199,
      40107515,
      20200719,
      80168665,
      25000299,
      80051476,
      80235541,
      80228648,
      80243969,
      80035532,
      80039912,
      40301283,
      80009581,
      80133371,
      80039750,
      80179869,
      40289733,
      80198871,
      80309522,
      80309083,
      80139930,
      40150692,
      40212652,
      40292299,
      80036160,
      80032982,
      80307040,
      80230525,
      80008645,
      80029171,
      80228806,
      40290041,
      40101649,
      20207060,
      80226163,
      80007269,
      40040791,
      80114020,
      80069320,
      40177302,
      20221669,
      80040958,
      40207218,
      40121496,
      80228698,
      80030325,
      80205031,
      80238029,
      80228641,
      80163130,
      40280562,
      80308223,
      80030306,
      80012919,
      80157516,
      80022927,
      40190196,
      40190623,
      80228652,
      80169202,
      80097130,
      80132097,
      40217037,
      80228861,
      80086325,
      40295603,
      80169196,
      80179543,
      40213984,
      40299585,
      80093477,
      20201595,
      25002564,
      20202373,
      80011739,
      80309878,
      40180945,
      40247958,
      80239216,
      80094525,
      20204203,
      40007750,
      80324945,
      20200342,
      40191272,
      80095010,
      40279853,
      40113807,
      40040774,
      80017320,
      80261834,
      80205905,
      40174919,
      80163312,
      80022727,
      80010322,
      80170865,
      40248130,
      80021883,
      40257138,
      80039922,
      80138127,
      80166284,
      80049110,
      80230607,
      40221610,
      80028390,
      80024273,
      40218279,
      80007262,
      40177665,
      80173073,
      80309895,
      40058203,
      80309868,
      80155678,
      40177663,
      40277789,
      20201520,
      80133363,
      80015724,
      40218295,
      80024173,
      80010506,
      80224871,
      80234105,
      40277618,
      40215192,
      89163327,
      80230563,
      25003404,
      80056108,
      80027113,
      40104726,
      40208396,
      40248164,
      40221231,
      20201495,
      80244250,
      40218821,
      80136023]
    return GPIDs.includes(gpid);
  }

  const canSchedule = handleCanSchedule(Number(user.gpId));

  useEffect(() => {
    reset();
  }, [reset]);

  if (canSchedule) return (
    <Fragment>
      <Grid container className={classes.container}>
        <Grid item>
          <Box px={2} className={classes.disclaimer}>
            <img src={VaccineIcon} alt="vaccine-icon" />
            <Typography variant="h1">Agende sua vacinação</Typography>
            <Typography>
              Chegou a sua hora de se prevenir, agende sua data para tomar a
              vacina contra gripe.
          </Typography>
            {!loading && (
              <Button
                endIcon={<ArrowForward />}
                variant="contained"
                color="primary"
                disableElevation
                className={classes.button}
                onClick={() => handleNext()}
              >
                Agendar
              </Button>
            )}
            {loading && <CircularProgress />}
          </Box>
        </Grid>
        <Grid item>
          <Box mt={10} px={3} textAlign="center">
            <Typography>
              No caso de dúvidas, entre em contato com o <strong>ENLACE</strong> através do telefone <strong>0800 709 2364</strong>.
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <LeaveButton />
    </Fragment>
  ); else return (
    <Fragment>
      <Grid container className={classes.container}>
        <Grid item>
          <Box px={2} className={classes.disclaimer}>
            <img src={VaccineIcon} alt="vaccine-icon" />
            <Typography variant="h1">Agende sua vacinação</Typography>
            <Typography>
              A vacinação acontecerá na sua localidade. Favor consultar calendário disponível no seu galpão
          </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box mt={10} px={3} textAlign="center">
            <Box marginY={4}>
              <Typography>{locationComplement}</Typography>
            </Box>
            <Typography>
              No caso de dúvidas, entre em contato com o <strong>ENLACE</strong> através do telefone <strong>0800 709 2364</strong>.
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <LeaveButton />
    </Fragment>
  );
}

export default VaccineFirstStep;
